import moment from 'moment';
import React, { PureComponent, PropTypes } from 'react';

import Heading from '../Common/Heading';
import Subheading from '../Common/Subheading';
import BookingDetailsContainer from '../../containers/BookingDetailsContainer';

import './ConfirmBooking.css';
import '../../fixed-header-view.css';

export default class ConfirmBooking extends PureComponent {
    static propTypes = {
        user: PropTypes.object.isRequired,
        plant: PropTypes.object.isRequired,
        travelReasons: PropTypes.object.isRequired,
        locations: PropTypes.object.isRequired,
        newBooking: PropTypes.object.isRequired,
    };

    render() {
        const { user, plant, travelReasons, locations, newBooking } = this.props;

        const selectedPlant = plant[newBooking.plantId].name;

        const journeyToLocation = newBooking.journeyToLocationId && locations[newBooking.journeyToLocationId] !== undefined
            ? locations[newBooking.journeyToLocationId].name
            : newBooking.otherJourneyToLocation;
        
        const reasonForTravel = newBooking.travelReasonId && travelReasons[newBooking.travelReasonId]
            ? travelReasons[newBooking.travelReasonId].name
            : newBooking.otherTravelReason;

        const booking = {
            // newBooking properties
            plantId: newBooking.plantId,
            pickupLocationId: newBooking.pickupLocationId,
            journeyToLocation,
            costCentreIds: newBooking.costCentreId ? [newBooking.costCentreId] : [],
            reasonForTravel,
            privateUse: newBooking.privateUse,
            // properties which cannot yet be set/changed when creating a booking
            driverPersonId: user.personId,
            returnToLocationId: newBooking.pickupLocationId, // Defaults to same as pickup
            additionalPlantIds: [],
            passengerPersonIds: [],
        };

        const bookingTimes = {
            start: moment(newBooking.startTime),
            end: moment(newBooking.endTime),
        };

        return (
            <div className="confirm-booking-wrapper fixed-header-view">
                <Heading title="Confirm Booking" />

                <div className="content">
                    <Subheading title={selectedPlant} />
                    <BookingDetailsContainer booking={booking} bookingTimes={bookingTimes} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Create/ConfirmBooking.jsx